import { render, staticRenderFns } from "./tip-popup.vue?vue&type=template&id=13d47911&scoped=true&"
import script from "./tip-popup.vue?vue&type=script&lang=js&"
export * from "./tip-popup.vue?vue&type=script&lang=js&"
import style0 from "./tip-popup.vue?vue&type=style&index=0&id=13d47911&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d47911",
  null
  
)

export default component.exports